export default "__VITE_ASSET__DVgb1oX5__"